import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ColorPaper } from '@/components/ui/Surface/ColorPaper';
import { AccountCircleBlueIcon } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * コンサルタント：案件の「企業からのコメント」を表示するためのコンポーネント（閲覧申請承認済み状態の詳細表示で使用）
 * @param props
 * @constructor
 */
export const RfpProfessionalRequestComment = (props) => {
    const { className = '', text } = props;
    return (_jsxs("div", Object.assign({ className: className }, { children: [_jsxs(IconTextGroup, Object.assign({ className: 'mb-16' }, { children: [_jsx(AccountCircleBlueIcon, { size: 'md' }), _jsx(Text, Object.assign({ color: 'base', isBold: true, size: 'md' }, { children: "\u4F01\u696D\u304B\u3089\u306E\u30B3\u30E1\u30F3\u30C8" }))] })), _jsx(ColorPaper, Object.assign({ bgColor: 'lightGray', className: 'p-12', space: 'none' }, { children: _jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: text })) }))] })));
};
